<template>
    <div>
        <el-form-item class="gcmcn-form-input add-email-container" :error="emailToAddError">
            <el-input
                ref="email-input"
                v-model="emailToAdd"
                size="mini"
                :keyup.enter.native="addEmail"
            ></el-input>
            <el-button type="primary" size="mini" @click="addEmail">Add email</el-button>
        </el-form-item>
        <div class="list-email-container" :class="{'emails-error': typeof listEmailIsValid === 'string'}">
            <div v-if="emailList.length === 0" class="no-email" @click="focusEmailInput">
                Please add at least one email
            </div>
            <template v-else>
                <email-item
                    ref="email-item"
                    v-for="email in emailList"
                    :key="email"
                    :email="email"
                    @remove-email-from-list="$emit('remove-email-from-list', $event)"
                ></email-item>
            </template>
        </div>
    </div>
</template>

<script>
import EmailItem from './email-item.vue';
export default {

    components: {
        EmailItem
    },

    props: {
        emailList: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {
            errorMsg: '',
            emailToAdd: '',
            emailToAddError: '',
        };
    },

    computed: {
        listEmailIsValid (){
            if(this.emailList.length === 0){
                return this.errorMsg = 'Please add at least one email'
            }

        },
    },

    mounted (){

    },

    methods: {
        validateAllEmails (){
            if(!this.$refs['email-item'] || this.$refs['email-item'].length === 0) return false;
            return this.$refs['email-item'].map((item) => item.emailIsValid).every((item) => item === true);
        },
        focusEmailInput (){
            this.$refs['email-input'].focus();
        },
        addEmail (event){
            event.preventDefault()
            if(this.emailToAdd.trim() === ''){
                return this.emailToAddError = 'The field is empty';
            }else if(!this.$store.getters.emailRegex.test(this.emailToAdd)){
                return this.emailToAddError = 'Email is not correctly formatted';
            }else{
                let emailsLowerCase = this.emailList.map((email) => email.toLowerCase());
                if(emailsLowerCase.indexOf(this.emailToAdd.toLowerCase()) !== -1){
                    return this.emailToAddError = `${this.emailToAdd.toLowerCase()} is already in the list`;
                }
            }
            this.emailToAddError = '';
            this.$emit('on-add-email', this.emailToAdd.toLowerCase());
            this.emailToAdd = '';
        },
    },
};
</script>

<style lang="scss">
.add-email-container .el-form-item__content{
    display: flex;
    margin-top: 10px;
    .el-input{
        margin-right: 15px;
    }
}
.list-email-container.emails-error{
    border-color: #F56C6C;
}
.list-email-container{
    color: #F56C6C;
    max-height: 300px;
    overflow: auto;
    min-height: 40px;
    background-color: #444444;
    border: 1px solid #111;
    margin-top: 25px;
    border-radius: 5px;
    padding: 5px;
    .no-email{
        text-align: center;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ListEmailValidatorVue/index.vue